module.exports = __webpack_public_path__ + "static/media/Payment.b6d8fb79.svg";